export const URL = {
  HOME: "/",
  USERS: "/users",
  CMS: "/cms",
  DASHBOARD: "/dashboard",
  TRANSACTIONS: "/transactions",
  BANK_TRANSFER: "/bank-tansfer",
  USER: "/user/:id",
  PROMO_CODES: "/promo-codes",
  ACTIVITY: "/activity",
  BONUSES: "/bonuses",
  BONUS2_ADMIN: "/bonus2-admin",
  TOKEN_ADMIN: "/token",
  KYC_FILES: "/kyc-files",
  REFERRALS: "/referrals",
  SETTINGS: "/settings",
  ADMINS: "/admins",
  CHALLENGES: "/challenges",
  GAME_MANAGEMENT: "/game-management",
  CMS_SEO: "/cms-seo",
  GGR_MONTHLY_REPORT: "/ggr-monthly-report",
  PROMOTIONS: "/promotions",
  PROMOTIONS_CREATE: "/promotions/create",
  PROMOTION: "/promotions/:id",
  TAGS: "/tags",
  TAG_RULES: "/tag-rules",
  BALANCE: "/balance",
  TOURNAMENTS: "/tournaments",
  TOURNAMENTS_CREATE: "/tournaments/create",
  TOURNAMENT: "/tournaments/:id",
  TOURNAMENT_EDIT: "/tournaments/:id/edit",
  TOURNAMENT_MONITOR: "/tournaments/:id/monitor",
  TOURNAMENT_PARTICIPANTS: "/tournaments/:id/participants",
  TOURNAMENT_PRIZES: "/tournaments/:id/prizes",
  TOURNAMENT_ANALYTICS: "/tournaments/:id/analytics",
  BETBY_BONUSES: "/betby-bonuses",
  RISK_DASHBOARD: "/risk",
  ROLE_MANAGEMENT: "/role-management",
  S2S_POSTBACKS: "/s2s-postbacks",
  NOT_FOUND: "*"
}

export const BONUS2_TAB_PARAM = "tab"
export const BONUS2_VIOLATIONS_URL = `${URL.BONUS2_ADMIN}?${BONUS2_TAB_PARAM}=violations`

export const REQ = {
  AUTH: {
    LOGIN: "v1/auth/login",
    LOGOUT: "v1/auth/logout",
    REFRESH: "v1/auth/refresh_token",
    MFA_LOGIN: "v1/auth/login/mfa",
    MFA_REMOVE_BY_BACKUP: "v1/auth/remove-mfa-by-backup"
  },
  USER: {
    GET: "v1/user",
    MFA: {
      SETUP: "v1/user/start-mfa",
      ENABLE: "v1/user/enable-mfa",
      VERIFY: "v1/user/verify-mfa",
      REMOVE: "v1/user/remove-mfa",
      REGENERATE_BACKUP_CODES: "v1/user/mfa-regenerate-backup-codes"
    }
  },
  CMS: {
    GET_ACTIVE: "/v1/cms/list"
  },
  ADMIN_DASHBOARD: {
    // The tenant's migration mode (money authority, bonus catalog, $TOKEN) — ungated, fetched
    // before the app renders. Replaces the build-time REACT_APP_MICROSERVICE_TENANTS mirror.
    TENANT_MODE: "/admin/tenant-mode",
    USERS: "/admin/dashboard/users",
    ADMINS: "/admin/dashboard/admins",
    USERS_COUNT: "/admin/dashboard/user-count",
    STATS: "/admin/dashboard/stats",
    STATS_BETTING: "/admin/dashboard/stats/betting",
    STATS_TRANSACTIONS: "/admin/dashboard/stats/transactions",
    STATS_DEPOSITORS: "/admin/dashboard/stats/depositors",
    STATS_BY_YEAR: "/admin/dashboard/stats/yearly",
    STATS_BY_MONTH: "/admin/dashboard/stats/monthly",
    STATS_BY_DAY: "/admin/dashboard/stats/daily",
    STATS_BY_HOUR: "/admin/dashboard/stats/hourly",
    GGR_SUMMARY: "/admin/dashboard/stats/ggr-summary",
    ACTIVITY: "/admin/activity",
    AFFILIATED_USERS: "/admin/dashboard/affiliated-users/:userId",
    USER: {
      USER: "/admin/user/user/:id",
      CREATE: "/admin/user/user",
      USER_BETS: "/admin/user/:id/bets",
      USER_BETBY_BETS: "/admin/user/:id/betby-bets",
      USER_TRANSACTIONS: "/admin/user/:id/transactions",
      USER_REFERRALS: "/admin/user/:id/referrals",
      USER_BALANCE: "/admin/user/:id/balance",
      USER_STATS_TABLE: "/admin/user/:id/stats-table",
      SWAP_USER_BALANCE: "/admin/user/:id/swap-balance",
      USER_REWARD_GAMES: "/admin/user/:id/reward-games",
      USER_ADD_REWARD_GAME: "/admin/user/user-add-reward-game",
      USER_DELETE_REWARD_GAME: "/admin/user/user-delete-reward-game",
      ACCOUNT_ACTIVITIES: "/admin/user/:id/account-activities",

      USER_COMMENTS: "/admin/user/:id/comments",
      ADD_COMMENTS: "/admin/user/comments",

      UPDATE_AFFILIATE: "/admin/user/:id/affiliate/:affiliateId",
      UPDATE_AFFILIATES_BULK: "/admin/user/:id/affiliates",
      RELEASE_AFFILIATE_NGR_EARNINGS: "/admin/user/:id/affiliate/release-ng-earnings",

      UPDATE_PERSONAL_PROFILE_MISC: "/admin/user/:id/personal-profile/misc",
      UPDATE_ACCOUNT_POLICY: "/admin/user/:id/account-policy",

      GET_BONUS: "/admin/user/:id/bonus",
      GET_TOTAL_BONUS: "/admin/user/:id/total-bonus",
      CANCEL_BONUS: "/admin/user/bonus/cancel",
      CLAIM_CUSTOM_BONUS: "/admin/user/bonus",

      ASSIGN_RELOAD: "/admin/user/reload",
      CANCEL_RELOAD: "/admin/user/reload/:id",
      GET_USER_RELOADS: "/admin/user/:id/reloads",

      DISABLE_MFA: "/admin/user/:id/disable-mfa",
      SEND_MESSAGE: "/admin/user/:id/send-message"
    },
    BONUSE: {
      LIST: "/admin/bonus/list",
      CREATE: "/admin/bonus/",
      UPDATE: "/admin/bonus/:id"
    },
    PROMO_CODES: {
      GET: "/admin/promo-codes",
      UPDATE: "/admin/promo-codes/:id",
      CREATE: "/admin/promo-codes",
      ASSIGN_OFFER: "admin/promo-codes/:userId/deposit-offer"
    },
    CMS: {
      GET: "/admin/cms/list",
      UPDATE: "/admin/cms/:id",
      CREATE: "/admin/cms",
      DELETE: "/admin/cms/:id"
    },
    CMSImage: {
      UPLOAD_IMAGE: "/admin/cms-image/upload-image"
    },
    CMSText: {
      GET: "/admin/cms/text/list",
      UPDATE: "/admin/cms/text/:id",
      CREATE: "/admin/cms/text",
      POLICIES_STATUS: "/admin/cms/text/policies-status",
      POLICY_TYPE_STATUS: "/admin/cms/text/policy-type-status"
    },
    BETS: {
      GET: "/admin/bets",
      BETBY: "/admin/bets/betby"
    },
    TRANSACTIONS: {
      GET: "/admin/transactions",
      DEPOSIT_TOTAL: "/admin/transactions/deposit-total",
      WITHDRAWAL_TOTAL: "/admin/transactions/withdrawal-total",
      WITHDRAWAL_PENDING: "/admin/transactions/withdrawal-pending",
      BETS_TOTAL: "/admin/transactions/bet-total",
      WINS_TOTAL: "/admin/transactions/win-total",
      AFFILIATE_TOTAL: "/admin/transactions/affiliate-total",
      RAKEBACK_TOTAL: "/admin/transactions/rakeback-total",
      PROMOCODE_TOTAL: "/admin/transactions/promo-total",
      CONFIRM: "/admin/transactions/confirm-payout",
      DECLINE: "/admin/transactions/decline-payout",
      PENDING_WITHDRAWALS_COUNT: "/admin/transactions/submitted-withdrawals-count"
    },
    BANK_TRANSFER: {
      APPROVE: "/admin/transactions/approve-bank-transfer"
    },
    PAYADMIT: {
      APPROVE: "/admin/transactions/payadmit-approve-payout",
      DECLINE: "/admin/transactions/payadmit-decline-payout",
      SUBMITTED: {
        APPROVE: "/admin/transactions/payadmit-submitted-approve-payout",
        DECLINE: "/admin/transactions/payadmit-submitted-decline-payout"
      }
    },
    CRYPTO: {
      APPROVE: "/admin/transactions/crypto-approve-payout",
      DECLINE: "/admin/transactions/crypto-decline-payout",
      SUBMITTED: {
        APPROVE: "/admin/transactions/crypto-submitted-approve-payout",
        DECLINE: "/admin/transactions/crypto-submitted-decline-payout"
      }
    },
    FORCE_DECLINE: "/admin/transactions/force-decline",
    GAMES: {
      GET_ALL: "admin/game/",
      GET_BY_IDS: "admin/game/by-ids",
      GET_SECTION: "admin/game/game-section",
      GET_BY_SECTION: "admin/game/sections",
      FREE_SPIN_GAMES: "/admin/game/free-spin-games",
      FREE_SPIN_GAME_IDS: "/admin/game/free-spin-games/ids",
      FREE_SPIN_GAME_PROVIDERS: "/admin/game/free-spin-game-providers",
      GAME_PRODUCERS: "/admin/game/game-producers",
      SECTION_ORDER: (key: string) => `/admin/game/sections/${key}/order`,
      HOMEPAGE_ORDER: "/admin/game/homepage/order",
      FORKED_GEOS: "/admin/game/forked-geos",
      IMAGE_VERTICAL_OVERRIDE: (id: string) => `/admin/game/${id}/image-vertical-override`,
      DESCRIPTION: (id: string) => `/admin/game/${id}/description`,
      SEO: (id: string) => `/admin/game/${id}/seo`,
      IMAGE_VERTICAL_OVERRIDE_PRESIGN: (id: string) => `/admin/game/${id}/image-vertical-override/presign`,
      CATEGORIES_LIST: "/admin/game/categories",
      CATEGORY_BY_KEY: (key: string) => `/admin/game/categories/${encodeURIComponent(key)}`,
      HOMEPAGE_ORDER_EXPORT_CSV: "/admin/game/homepage/order/export-csv",
      HOMEPAGE_ORDER_IMPORT_CSV: "/admin/game/homepage/order/import-csv",
      SECTION_ORDERS_EXPORT_CSV: "/admin/game/sections/orders/export-csv",
      SECTION_ORDERS_IMPORT_CSV: "/admin/game/sections/orders/import-csv",
      SECTION_ORDER_EXPORT_CSV: (key: string) => `/admin/game/sections/${encodeURIComponent(key)}/order/export-csv`,
      SECTION_ORDER_IMPORT_CSV: (key: string) => `/admin/game/sections/${encodeURIComponent(key)}/order/import-csv`,
      TOGGLE_ENABLED: (id: string) => `/admin/game/${id}/enabled`,
      UPDATE_STATUS: "/admin/game/update/status",
      TRIGGER_UPDATE: "/admin/game/update/trigger"
    },
    SEO: {
      OVERRIDES: "/admin/seo/overrides",
      OVERRIDES_BY_PATH: "/admin/seo/overrides/path",
      OVERRIDE_BY_ID: (id: string) => `/admin/seo/overrides/${encodeURIComponent(id)}`
    },
    CMS_SEO: {
      PAGES: "/admin/cms/pages",
      PAGE_BY_ID: (id: string) => `/admin/cms/pages/${encodeURIComponent(id)}`,
      PAGE_PUBLISH: (id: string) => `/admin/cms/pages/${encodeURIComponent(id)}/publish`,
      PAGE_DUPLICATE: (id: string) => `/admin/cms/pages/${encodeURIComponent(id)}/duplicate`,
      PAGE_VERSIONS: (id: string) => `/admin/cms/pages/${encodeURIComponent(id)}/versions`,
      PAGE_VERSION_RESTORE: (id: string, version: number) =>
        `/admin/cms/pages/${encodeURIComponent(id)}/versions/${version}/restore`,
      PAGE_PREVIEW_TOKEN: (id: string) => `/admin/cms/pages/${encodeURIComponent(id)}/preview-token`,
      VALIDATE_SLUG: "/admin/cms/pages/validate-slug",
      SPORTSBOOK_SPORTS: "/admin/cms/sportsbook-sports",
      SEO_RULES: "/admin/cms/seo-rules",
      SEO_RULE_BY_ID: (id: string) => `/admin/cms/seo-rules/${encodeURIComponent(id)}`,
      SEO_RULE_TEST: "/admin/cms/seo-rules/test",
      REDIRECTS: "/admin/cms/redirects",
      REDIRECT_BY_ID: (id: string) => `/admin/cms/redirects/${encodeURIComponent(id)}`,
      REDIRECTS_IMPORT: "/admin/cms/redirects/import",
      MEDIA: "/admin/cms/media",
      MEDIA_BY_ID: (id: string) => `/admin/cms/media/${encodeURIComponent(id)}`,
      ROBOTS: "/admin/cms/robots",
      SITEMAP: "/admin/cms/sitemap",
      SITE_URL: "/admin/cms/site-url"
    },
    PROVIDERS: {
      GET: "admin/providers/",
      TOGGLE_ENABLED: (id: string) => `/admin/providers/${id}/enabled`,
      UPDATE_FEE_RATE: (id: string) => `/admin/providers/${id}/fee-rate`,
      FEE_EXPORT: "/admin/providers/fees/export",
      FEE_IMPORT: "/admin/providers/fees/import",
      RESTRICTIONS: {
        LIST: "/admin/providers/restrictions",
        GET: (id: string) => `/admin/providers/restrictions/${id}`,
        UPSERT: (id: string) => `/admin/providers/restrictions/${id}`,
        DELETE: (id: string) => `/admin/providers/restrictions/${id}`
      }
    },
    KYC_FILES: {
      GET: "/admin/kyc-files",
      GET_ALL: "/admin/kyc-files/all",
      UPDATE: "/admin/kyc-files",
      PENDING_COUNT: "/admin/kyc-files/pending-count",
      CHECK_DUPLICATE: "/admin/kyc-files/check-duplicate",
      KYC_READ: "v1/upload/generate-read-presigned-url"
    },
    KYC_REQUEST: {
      SEND: "/admin/kyc-request",
      CHECK: (userId: string) => `/admin/kyc-request/${userId}`
    },
    PAYMENTS: {
      CUR_EXCHANGE_RATES: "v1/payments/cur-exchange-rates"
    },
    TENANTS: {
      LIST: "/admin/tenants",
      UPDATE: "/admin/tenants/:id/update"
    },
    REFERRALS: {
      LIST: "/admin/referrals/referrers",
      REFERRALS_CODES_LIST: "/admin/referrals/referrals-codes/:referrerId",
      REFERRALS_LIST: "/admin/referrals/referrals/:code",
      UPDATE_ALL_AFFILIATES: "/admin/referrals/referrals/affiliates"
    },
    SETTINGS: {
      ALL: "/admin/settings",
      RCOIN: "/admin/settings/rcoin",
      LANGUAGES: "/admin/settings/languages",
      LOCALE_URLS: "/admin/settings/locale-urls",
      BLOCKED_GEOS: "/admin/settings/blocked-geos",
      EMAIL_SIGNIN: "/admin/settings/email-signin",
      KYC: "/admin/settings/kyc",
      WITHDRAWALS: "/admin/settings/withdrawals",
      WITHDRAWALS_AND_DEPOSITS_LIMITS: "/admin/settings/withdrawals-and-deposits-limits",
      VIP: "/admin/settings/vip",
      GGR: "/admin/settings/ggr",
      GGR_HISTORY: "/admin/settings/ggr/history",
      SPORTSBOOK_GGR: "/admin/settings/sportsbook-ggr",
      SPORTSBOOK_GGR_HISTORY: "/admin/settings/sportsbook-ggr/history",
      GET_AFFILIATE_DEFAULTS: "/admin/settings/affiliate-defaults",
      UPDATE_AFFILIATE_DEFAULTS: "/admin/settings/affiliate-defaults",
      RESET_TARGETS: "/admin/settings/reset-targets",
      RESET_ALL: "/admin/settings/reset-all",
      RESET_SPECIFIC: "/admin/settings/reset/:target",
      HISTORY: "/admin/settings/history/:target",
      LIVE_CHAT: "/admin/settings/live-chat",
      CUSTOMERIO: "/admin/settings/customerio",
      CUSTOMERIO_TEST: "/admin/settings/customerio/test",
      CUSTOMERIO_CREDENTIALS: "/admin/settings/customerio/credentials",
      EMAIL_PROVIDER: "/admin/settings/email-provider",
      CRYPTO_COINS: "/admin/settings/crypto-coins",
      VERIFICATION_FIELDS: "/admin/settings/verification-fields",
      GIFTS: "/admin/settings/gifts",
      BETS_TABLES: "/admin/settings/bets-tables",
      GAME_CARD_CONFIG: "/admin/settings/game-card-config",
      FONT_CONFIG: "/admin/settings/font-config",
      FAKE_BETS: "/admin/settings/fake-bets",
      FAKE_BETS_SEED: "/admin/settings/fake-bets/seed"
    },
    POSTBACKS: {
      CONFIG: "/admin/postbacks/config",
      LIST: "/admin/postbacks",
      CREATE: "/admin/postbacks",
      ITEM: (id: string) => `/admin/postbacks/${id}`,
      TEST: (id: string) => `/admin/postbacks/${id}/test`,
      LOGS: "/admin/postbacks/logs",
      REPLAY: (id: string) => `/admin/postbacks/logs/${id}/replay`
    },
    REPORTS: {
      GGR_MONTHLY_REPORT_BY_PROVIDER: "/admin/reports/ggr-monthly-by-provider",
      GGR_MONTHLY_REPORT_BY_GAME: "/admin/reports/ggr-monthly-by-game",
      GGR_SNAPSHOT: "/admin/reports/snapshot",
      SPORTSBOOK_GGR_SNAPSHOT: "/admin/reports/sportsbook-snapshot"
    },
    PROMOTIONS: {
      LIST: "/admin/promotions",
      DETAIL: (id: string) => `/admin/promotions/${id}`
    },
    TAGS: {
      LIST: "/admin/tags",
      STATS: "/admin/tags/stats",
      CREATE: "/admin/tags",
      UPDATE: "/admin/tags/:id",
      DELETE: "/admin/tags/:id"
    },
    USER_TAGS: {
      LIST: "/admin/user-tags/:userId/tags",
      AVAILABLE: "/admin/user-tags/:userId/tags/available",
      ASSIGN: "/admin/user-tags/:userId/tags/:tagId",
      REMOVE: "/admin/user-tags/:userId/tags/:tagId",
      HISTORY: "/admin/user-tags/:userId/tags/history"
    },
    CUSTOM_HALLS: {
      GET: "/admin/user/:userId/custom-halls",
      ADD: "/admin/user/:userId/custom-halls/:provider",
      REMOVE: "/admin/user/:userId/custom-halls/:provider"
    },
    TAG_RULES: {
      FIELDS: "/admin/tag-rules/fields",
      LIST: "/admin/tag-rules",
      CREATE: "/admin/tag-rules",
      GET_ONE: "/admin/tag-rules/:id",
      UPDATE: "/admin/tag-rules/:id",
      DELETE: "/admin/tag-rules/:id",
      RUN_ONE: "/admin/tag-rules/:id/run",
      RUN_BATCH: "/admin/tag-rules/run-batch",
      SWEEP_STATUS: "/admin/tag-rules/sweep-status",
      HISTORY: "admin/tag-rules/history",
      HISTORY_BY_ID: "admin/tag-rules/history/:id"
    },
    BALANCE: {
      ROUTES: "/admin/balance/routes",
      ROUTES_CREATE: "/admin/balance/routes",
      ROUTES_UPDATE: "/admin/balance/routes/:id",
      ROUTES_PROCESSORS: "/admin/balance/routes/processors",

      PROCESSORS: "/admin/balance/processors",
      METHODS: "/admin/balance/processors/:processor/methods",
      TERMINALS: "/admin/balance/processors/:processor/methods/:payment_method/terminals",
      TERMINAL_FEE: "/admin/balance/terminals/fee",
      FEES_EXPORT: "/admin/balance/fees/export",
      FEES_IMPORT: "/admin/balance/fees/import",
      PSP_BALANCES: "/admin/balance/psp-balances",
      PSP_BALANCES_TOP_UP: "/admin/balance/psp-balances/top-up",
      PSP_BALANCES_RESET: "/admin/balance/psp-balances/reset",
      PSP_BALANCES_LEDGER: "/admin/balance/psp-balances/:processor/:payment_method/ledger",
      TRANSACTIONS_EXPORT: "/admin/balance/transactions/export",
      SETTLEMENT_REPORT: "/admin/balance/settlement-report",
      RESET_AVAILABLE: "/admin/balance/reset-available"
    },
    BETBY_BONUS: {
      TEMPLATES_SYNC: "/admin/betby/bonus/templates/sync",
      TEMPLATES: "/admin/betby/bonus/templates",
      TEMPLATE: (id: string) => `/admin/betby/bonus/templates/${id}`,
      LIST: "/admin/betby/bonus/list",
      GIVE: "/admin/betby/bonus/give",
      REVOKE: "/admin/betby/bonus/revoke"
    },
    PREFERENCES: {
      GET: "/admin/me/preferences",
      UPDATE: "/admin/me/preferences"
    },
    TOURNAMENTS: {
      LIST: "/admin/tournaments",
      CREATE: "/admin/tournaments",
      GET: "/admin/tournaments/:id",
      UPDATE: "/admin/tournaments/:id",
      DELETE: "/admin/tournaments/:id",
      PERMANENT_DELETE: "/admin/tournaments/:id/permanent",
      START: "/admin/tournaments/:id/start",
      END: "/admin/tournaments/:id/end",
      DUPLICATE: "/admin/tournaments/:id/duplicate",
      PARTICIPANTS: "/admin/tournaments/:id/participants",
      ANALYTICS: "/admin/tournaments/:id/analytics",
      DISTRIBUTE_PRIZES: "/admin/tournaments/:id/distribute-prizes",
      RECALCULATE_LEADERBOARD: "/admin/tournaments/:id/recalculate-leaderboard",
      DISQUALIFICATION_STATS: "/admin/tournaments/:id/disqualification-stats",
      DISQUALIFIED_SPINS: "/admin/tournaments/:id/disqualified-spins",
      TEST_VALIDATION: "/admin/tournaments/:id/test-validation",
      CHAT_MESSAGES: "/admin/tournaments/:id/chat",
      CHAT_DELETE_MESSAGE: "/admin/tournaments/:id/chat/:messageId",
      CHAT_RESTORE_MESSAGE: "/admin/tournaments/:id/chat/:messageId/restore",
      REFERRAL_REWARDS: "/admin/tournaments/:id/referral-rewards",
      PRESETS_LIST: "/admin/tournaments/presets/list",
      PRESETS_CREATE: "/admin/tournaments/presets/create",
      PRESETS_SEED: "/admin/tournaments/presets/seed",
      PRESETS_GET: "/admin/tournaments/presets/:presetId",
      PRESETS_UPDATE: "/admin/tournaments/presets/:presetId",
      PRESETS_DELETE: "/admin/tournaments/presets/:presetId"
    },
    RISK: {
      DASHBOARD: "/admin/risk/dashboard",
      PLAYERS: "/admin/risk/players",
      PLAYER: "/admin/risk/player/:userId",
      PLAYER_HISTORY: "/admin/risk/player/:userId/history",
      PLAYER_DUPLICATES: "/admin/risk/player/:userId/duplicates",
      REVIEW_DUPLICATE: "/admin/risk/player/:userId/duplicates/:matchId",
      MANUAL_ACTION: "/admin/risk/player/:userId/manual-action",
      RECALCULATE_PLAYER: "/admin/risk/player/:userId/recalculate",
      SETTINGS_LEVELS: "/admin/risk/settings/levels",
      SETTINGS_DUPLICATES: "/admin/risk/settings/duplicates",
      ACTIONS: "/admin/risk/actions",
      ACTION_DETAIL: "/admin/risk/actions/:id",
      ACTION_TOGGLE: "/admin/risk/actions/:id/toggle",
      RECALCULATE_ALL: "/admin/risk/recalculate-all",
      ACTION_LOGS: "/admin/risk/action-logs",
      DUPLICATES: "/admin/risk/duplicates",
      DUPLICATES_REVIEW: "/admin/risk/duplicates/:matchId",
      BLACKLIST: "/admin/risk/blacklist",
      BLACKLIST_ENTRY: "/admin/risk/blacklist/:id",
      REVIEW_QUEUE: "/admin/risk/review-queue",
      REVIEW_QUEUE_RESOLVE: "/admin/risk/review-queue/:id"
    },
    CHALLENGES: {
      GET_ALL: "/admin/challenge",
      GET: "/admin/challenge/:id",
      CREATE: "/admin/challenge",
      UPDATE: "/admin/challenge/:id",
      DELETE: "/admin/challenge/:id",
      ACTIVATE: "/admin/challenge/:id/activate",
      DEACTIVATE: "/admin/challenge/:id/deactivate"
    },
    ROLE_MANAGEMENT: {
      MATRIX: "/admin/role-management/matrix",
      ROLES: "/admin/role-management/roles",
      ROLES_LOOKUP: "/admin/role-management/roles/lookup",
      ROLE: "/admin/role-management/roles/:id",
      GRANT: "/admin/role-management/role/:role/grant",
      REVOKE: "/admin/role-management/role/:role/revoke"
    },
    TOKEN: {
      CONFIG: "/admin/token/config",
      CONFIG_CHANGES: "/admin/token/config/changes",
      POOL: "/admin/token/pool",
      POOL_TOP_UP: "/admin/token/pool/top-up",
      DISTRIBUTIONS: "/admin/token/distributions",
      DISTRIBUTIONS_TRIGGER: "/admin/token/distributions/trigger",
      ANALYTICS: "/admin/token/analytics",
      USER: "/admin/token/user/:userId",
      ADJUST_BALANCE: "/admin/token/adjust-balance",
      RECONCILE_PURCHASE: "/admin/token/reconcile-purchase",
      TERMINATE_POSITION: "/admin/token/terminate-position",
      BULK_GRANT: "/admin/token/bulk-grant",
      BULK_GRANT_PREVIEW: "/admin/token/bulk-grant/preview",
      BULK_GRANT_ACTIVE: "/admin/token/bulk-grant/active",
      BULK_GRANT_CANCEL: "/admin/token/bulk-grant/:jobId/cancel"
    },
    BONUS2: {
      LIST: "/admin/bonus2/list",
      TABLE: "/admin/bonus2/table",
      ANALYTICS: "/admin/bonus2/analytics",
      GET: "/admin/bonus2/:id",
      CREATE: "/admin/bonus2",
      UPDATE: "/admin/bonus2/:id",
      DELETE: "/admin/bonus2/:id",
      REACTIVATE: "/admin/bonus2/:id/reactivate",
      // SOFT-644 — retiring a template that player bonuses reference. DELETE is refused for
      // those ("Template is referenced by player bonuses"), so archiving hides it from the
      // main list instead, leaving the row and every player reference intact.
      ARCHIVE: "/admin/bonus2/:id/archive",
      UNARCHIVE: "/admin/bonus2/:id/unarchive",
      // SOFT-736 — a game's per-currency bet ladders (the tiers a free-spins stake must be
      // picked from) and the button that fills in a currency the game has no ladder for. They
      // live under /admin/bonus2, NOT /admin/game, so a bonus-only admin (PAGE_BONUS2 without
      // game management) can read the tiers the bonus form refuses to save without.
      GAME_BET_VALUES: "/admin/bonus2/games/:gameId/bet-values",
      SYNC_GAME_BET_VALUES: "/admin/bonus2/games/:gameId/sync-bet-values",
      PLAYER: {
        LIST: "/admin/bonus2/player/:userId",
        SUBSCRIBE: "/admin/bonus2/subscribe",
        TAG_AUDIENCE: "/admin/bonus2/tag-audience",
        SUBSCRIBE_BULK: "/admin/bonus2/subscribe-bulk",
        ACTIVATE: "/admin/bonus2/activate/:playerBonusId",
        CANCEL: "/admin/bonus2/cancel/:playerBonusId",
        HISTORY: "/admin/bonus2/history/:playerBonusId"
      },
      VIOLATIONS: {
        LIST: "/admin/bonus2/violations/list",
        DISMISS: "/admin/bonus2/violations/:id/dismiss" // Fix 01 — soft-dismiss
      },
      GAME_CONTRIBUTION: {
        UPDATE: "/admin/bonus2/game-contribution/:gameType"
      },
      GAME_GROUPS: {
        LIST: "/admin/bonus2/game-groups/list",
        UPSERT: "/admin/bonus2/game-groups",
        DELETE: "/admin/bonus2/game-groups/:groupId"
      },
      BONUS_BANNERS: {
        LIST: "/admin/bonus2/bonus-banners/list",
        UPSERT: "/admin/bonus2/bonus-banners",
        DELETE: "/admin/bonus2/bonus-banners/:bannerId"
      },
      FREE_SPINS: {
        STATS: "/admin/bonus2/:bonusId/free-spins/stats",
        ACTIVE: "/admin/bonus2/free-spins/active",
        AWARD: "/admin/bonus2/free-spins/award",
        EXTEND: "/admin/bonus2/free-spins/:playerBonusId/extend",
        CANCEL: "/admin/bonus2/free-spins/:playerBonusId/cancel"
      },
      PROMO_CODES: {
        LIST: "/admin/bonus2/promo-codes/list",
        VALIDATE: "/admin/bonus2/promo-codes/validate/:code",
        USAGE: "/admin/bonus2/promo-codes/:code/usage",
        CREATE: "/admin/bonus2/promo-codes/create",
        GENERATE: "/admin/bonus2/promo-codes/generate",
        TOGGLE: "/admin/bonus2/promo-codes/:id/toggle",
        ARCHIVE: "/admin/bonus2/promo-codes/:id/archive",
        DELETE: "/admin/bonus2/promo-codes/:id"
      }
    }
  }
}
